module.exports = __webpack_public_path__ + "static/media/anne-hathaway-icon.5ce856be.jpg";